import { onScopeDispose, Ref, watch } from 'vue';

/** The body class that hides the GPTHelp bubble (`GpthelpWidget.vue`). */
export const HELP_BUBBLE_HIDDEN_CLASS = 'gpthelp-bubble-hidden';

/** Everything hiding the bubble right now (several sheets may be open). */
const hiders = new Set<symbol>();

function sync() {
  document.body.classList.toggle(HELP_BUBBLE_HIDDEN_CLASS, hiders.size > 0);
}

/**
 * Hides the GPTHelp bubble while `active` is true: a bottom sheet's buttons
 * sit where the bubble floats.
 */
export function useHideHelpBubble(active: Ref<boolean>) {
  const token = Symbol('help-bubble-hider');
  watch(
    active,
    (hide) => {
      if (hide) hiders.add(token);
      else hiders.delete(token);
      sync();
    },
    { immediate: true }
  );
  onScopeDispose(() => {
    hiders.delete(token);
    sync();
  });
}
